import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ariaLabelExpand: {
		id: 'development-summary-development-field.common.development-field-wrapper.aria-label-expand',
		defaultMessage: 'Expand',
		description: 'Aria label for expand button.',
	},
	ariaLabelCollapse: {
		id: 'development-summary-development-field.common.development-field-wrapper.aria-label-collapse',
		defaultMessage: 'Collapse',
		description: 'Aria label for collapse button.',
	},
});
